import { Icon } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { SpinButton } from 'office-ui-fabric-react/lib/SpinButton';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Position } from 'office-ui-fabric-react/lib/utilities/positioning';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataSouhait } from '../../data/DataSouhait.jsx';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxOrigineCommerciale } from '../ComboBox/ComboBoxOrigineCommerciale';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';
import { EUIDatePicker } from '../EUI/EUIDatePicker.jsx';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { Upload } from '../Outils/Upload';
import './FicheSouhait_MaisonIndividuelle.css';

/****************************************************************
PROPS :
idSouhait : id du souhait en cours de modification
idContact : id du contact
onAnnuleFiche : événement déclenché lors de la fermeture du panel
onAffichePanelSouhait : indique si le panel est ouvert ou non
onEnregistrementFiche : événements déclenché lors de l'enregistrement du panel
****************************************************************/

var objetState = {
    idContact: 0,
    idSouhait: 0,
    souhait: {},

    peutCreerSouhait: false,
    peutModifierSouhait: false,

    enCoursDeTraitement: false,

    onActiveBoutonEnregistrer: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''

    //titrePanel: 'Feuille de découverte'
};

export class FicheSouhaitMaisonIndividuelle extends Component {
    _creationContent() {
        let titrePanel = (this.state.idSouhait === 0 ? 'Création de souhait' : 'Edition de souhait');

        return (<Panel
            isOpen={this.props.onAffichePanelSouhait}
            onDismiss={() => this._onAnnulation()}
            onOpen={() => this._onOpen()}
            type={PanelType.extraLarge}
            headerText={titrePanel}
            closeButtonAriaLabel="Fermer"
            onRenderFooterContent={() => this._onRenderFooterContentPanel()}
        >
            <div className="ms-Grid" dir="ltr">
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12 ms-xl3" name='divOrigineCommerciale'>
                        <ComboBoxOrigineCommerciale
                            avecValeurDefaut={false}
                            onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "souhait", "rechercheOrigineCommerciale", option.key, this._onVerificationFormulaire)}
                            required
                            selectedKey={this.state.souhait.rechercheOrigineCommerciale}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl3">
                        <EUIDatePicker
                            label="Date RDV1"
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "rechercheDateRDV1", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                            value={this.state.souhait.rechercheDateRDV1}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl3">
                        <EUIDatePicker
                            label="Date RDV2"
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "rechercheDateRDV2", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                            value={this.state.souhait.rechercheDateRDV2}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl3">
                        <EUIDatePicker
                            label="Date RDV3"
                            onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "rechercheDateRDV3", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                            value={this.state.souhait.rechercheDateRDV3}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="Lightbulb" /> Motivations d'achat</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Qu'est ce qui vous amène aujourd'hui à avoir un projet de construction ? Pourquoi maintenant ?"
                                maxLength={MaxLengths.souhait.mi_ButProjetConstruction}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ButProjetConstruction", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_ButProjetConstruction}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Connaissez-vous quelqu'un de votre entourage qui a fait construire et comment cela s'est-il passé ?"
                                maxLength={MaxLengths.souhait.mi_ConnaissanceEntourageConstruction}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ConnaissanceEntourageConstruction", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_ConnaissanceEntourageConstruction}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Avez-vous un conseiller (quelqu'un qui va vous appuyer techniquement) ?"
                                maxLength={MaxLengths.souhait.mi_ConseillerTechnique}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ConseillerTechnique", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_ConseillerTechnique}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Connaissez-vous le groupe ? Comment nous avez-vous connu ?"
                                maxLength={MaxLengths.souhait.mi_ConnaissanceGroupe}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ConnaissanceGroupe", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_ConnaissanceGroupe}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Qu'attendez-vous d'un constructeur ?"
                                maxLength={MaxLengths.souhait.mi_AttenteConstructeur}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_AttenteConstructeur", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_AttenteConstructeur}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Quelles démarches avez-vous effectuées pour votre projet ?"
                                maxLength={MaxLengths.souhait.mi_DemarchesEffectueesProjet}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_DemarchesEffectueesProjet", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_DemarchesEffectueesProjet}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Avez-vous rencontré certains de mes « confrères » ? Qu'en avez-vous retenu ?"
                                maxLength={MaxLengths.souhait.mi_ConfreresRencontres}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ConfreresRencontres", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_ConfreresRencontres}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUIDatePicker
                                label="Quand souhaitez-vous entrer dans votre futur logement ?"
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "mI_DateEntreeSouhaitee", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_DateEntreeSouhaitee}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUIDatePicker
                                label="Est-ce-que vous vous êtes fixé une date pour prendre votre décision ?"
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "mI_DatePrevisionnelleDecision", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_DatePrevisionnelleDecision}
                            />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-Grid-col ms-sm12">
                            <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="Family" /> Situation personnelle</div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <div className="ms-Grid-col ms-sm12 ms-xl4">
                                <EUIDatePicker
                                    label="Enfant 1"
                                    onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "dateNaissanceEnfant1", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                    value={this.state.souhait.dateNaissanceEnfant1}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl4">
                                <EUIDatePicker
                                    label="Enfant 2"
                                    onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "dateNaissanceEnfant2", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                    value={this.state.souhait.dateNaissanceEnfant2}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl4">
                                <EUIDatePicker
                                    label="Enfant 3"
                                    onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "dateNaissanceEnfant3", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                    value={this.state.souhait.dateNaissanceEnfant3}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl4">
                                <EUIDatePicker
                                    label="Enfant 4"
                                    onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "dateNaissanceEnfant4", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                    value={this.state.souhait.dateNaissanceEnfant4}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl4">
                                <EUIDatePicker
                                    label="Enfant 5"
                                    onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "dateNaissanceEnfant5", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                    value={this.state.souhait.dateNaissanceEnfant5}
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <Toggle
                                    label="Avez-vous des animaux ?"
                                    onText="Oui"
                                    offText="Non"
                                    checked={this.state.souhait.mI_PossedeAnimaux}
                                    onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_PossedeAnimaux", isChecked, this._onVerificationFormulaire)}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <Toggle
                                    label="Est-ce que vous êtes bricoleur ?"
                                    onText="Oui"
                                    offText="Non"
                                    checked={this.state.souhait.mI_EstBricoleur}
                                    onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_EstBricoleur", isChecked, this._onVerificationFormulaire)}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12">
                                <EUITextField
                                    label="Quel est votre mode de vie ? Vous recevez beaucoup ?"
                                    maxLength={MaxLengths.contact.mi_ModeDeVie}
                                    multiline
                                    onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                    onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ModeDeVie", newValue, this._onVerificationFormulaire)}
                                    rows={3}
                                    value={this.state.souhait.mI_ModeDeVie}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12">
                                <EUITextField
                                    label="Avez-vous des hobbies ?"
                                    maxLength={MaxLengths.contact.mi_Hobbies}
                                    multiline
                                    onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                    onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Hobbies", newValue, this._onVerificationFormulaire)}
                                    rows={3}
                                    value={this.state.souhait.mI_Hobbies}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <SpinButton
                                    label="Combien de véhicules avez-vous ?"
                                    labelPosition={Position.top}
                                    value={this.state.souhait.mI_NbVehicules}
                                    min={0}
                                    max={10}
                                    step={1}
                                    onValidate={(value) => {
                                        if (Number(value) > 10 || Number(value) < 0 || value.trim().length === 0 || isNaN(+value)) {
                                            return '0';
                                        }
                                        else {
                                            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbVehicules', String(value), 'fr', this._onVerificationFormulaire);
                                        }

                                        return String(value);
                                    }}
                                    onIncrement={(value) => {
                                        value = Number(value);
                                        if ((Number(value) + 1) > 10) {
                                            return '10';
                                        } else {
                                            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbVehicules', String(value + 1), 'fr', this._onVerificationFormulaire);
                                            return String(value + 1);
                                        }
                                    }}
                                    onDecrement={(value) => {
                                        value = Number(value);
                                        if ((Number(value) - 1) < 0) {
                                            return '0';
                                        } else {
                                            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbVehicules', String(value - 1), 'fr', this._onVerificationFormulaire);
                                            return String(value - 1);
                                        }
                                    }}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <Toggle
                                    label="Moto ?"
                                    onText="Oui"
                                    offText="Non"
                                    checked={this.state.souhait.mI_PossedeMoto}
                                    onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_PossedeMoto", isChecked, this._onVerificationFormulaire)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="Suitcase" /> Situation professionnelle</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUITextField
                                label="A quel endroit travaillez-vous ?"
                                maxLength={MaxLengths.contact.mi_LieuTravail}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_LieuTravail", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_LieuTravail}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Depuis combien de temps ?"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'souhait', 'mI_NbAnneesTravail', false, 0)}
                                suffix="années"
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'souhait', 'mI_NbAnneesTravail', this._onVerificationFormulaire)}
                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbAnneesTravail', e.target.value, 'fr', this._onVerificationFormulaire)}
                                onChanged={value => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbAnneesTravail', value, 'fr', this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'mI_NbAnneesTravail', e, false, 0)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Que faites-vous exactement ?"
                                maxLength={MaxLengths.contact.profession}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "profession", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.profession}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Quelles sont les évolutions possibles ?"
                                maxLength={MaxLengths.contact.mi_EvolutionsPossiblesTravail}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_EvolutionsPossiblesTravail", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_EvolutionsPossiblesTravail}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUIComboBox
                                idValeurParDefaut="0"
                                label="Type de contrat"
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ContratSituationProfessionnelle", option.key, this._onVerificationFormulaire)}
                                options={[
                                    { key: 'CDI', text: 'CDI' },
                                    { key: 'CDD', text: 'CDD' },
                                    { key: 'Intérim', text: 'Intérim' },
                                    { key: 'Sans emploi', text: 'Sans emploi' }
                                ]}
                                selectedKey={this.state.souhait.mI_ContratSituationProfessionnelle}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Revenus annuels"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'souhait', 'revenusAnnuels', false, 2)}
                                suffix="€ / an"
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'souhait', 'revenusAnnuels', this._onVerificationFormulaire)}
                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'revenusAnnuels', e.target.value, 'fr', this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'revenusAnnuels', e, false, 2)}
                            />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="Money" /> Eléments financiers</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Comment envisagez-vous votre financement ?"
                                maxLength={MaxLengths.souhait.mi_FinancementEnvisage}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_FinancementEnvisage", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_FinancementEnvisage}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUIComboBox
                                idValeurParDefaut="0"
                                label="Crédit total ou apport + crédit ?"
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Credit", option.key, this._onVerificationFormulaire)}
                                options={[
                                    { key: 'Crédit total', text: 'Crédit total' },
                                    { key: 'Apport + crédit', text: 'Apport + crédit' }
                                ]}
                                selectedKey={this.state.souhait.mI_Credit}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Quelle mensualité souhaitez-vous consacrer ?"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'souhait', 'mI_MensualiteSouhaitee', false, 0)}
                                suffix="€"
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'souhait', 'mI_MensualiteSouhaitee', this._onVerificationFormulaire)}
                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_MensualiteSouhaitee', e.target.value, 'fr', this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'mI_MensualiteSouhaitee', e, false, 0)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Disposez-vous d'un apport personnel ?"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'souhait', 'rechercheApportPersonnel', false, 2)}
                                suffix="€"
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'souhait', 'rechercheApportPersonnel', this._onVerificationFormulaire)}
                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'rechercheApportPersonnel', e.target.value, 'fr', this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'rechercheApportPersonnel', e, false, 2)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <Toggle
                                label="Avez-vous des prêts en cours ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_APretEnCours}
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_APretEnCours", isChecked, this._onVerificationFormulaire)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <Toggle
                                label="Avez-vous des pensions alimentaires ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_APensionsAlimentaires}
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_APensionsAlimentaires", isChecked, this._onVerificationFormulaire)}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Avez-vous d'autres sources de revenus ? (assurance vie, épargne, loyer rente, …)"
                                maxLength={MaxLengths.contact.mi_AutresSourcesRevenus}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_AutresSourcesRevenus", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_AutresSourcesRevenus}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Quelqu'un peut-il vous aider à financer votre projet ?"
                                maxLength={MaxLengths.souhait.mi_PersonneAidanteFinancement}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_PersonneAidanteFinancement", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_PersonneAidanteFinancement}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <Toggle
                                label="Avez-vous rencontré des banques ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_ARencontreBanque}
                                onChange={(e, isChecked) => {
                                    let champAVider = "mI_BanquesRencontrees";

                                    if (isChecked) {
                                        champAVider = "mI_DateRdvPartenaire";
                                    }

                                    let souhaitTrav = { ...this.state.souhait };
                                    souhaitTrav.mI_ARencontreBanque = isChecked;
                                    souhaitTrav[champAVider] = null;

                                    this.setState({
                                        souhait: souhaitTrav
                                    }, this._onVerificationFormulaire);
                                }}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUITextField
                                disabled={!this.state.souhait.mI_ARencontreBanque}
                                label="Si OUI lesquelles ?"
                                maxLength={MaxLengths.souhait.mi_BanquesRencontrees}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_BanquesRencontrees", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_BanquesRencontrees}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUIDatePicker
                                disabled={this.state.souhait.mI_ARencontreBanque}
                                label="Si NON : Date de RDV partenaire"
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "mI_DateRdvPartenaire", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_DateRdvPartenaire}
                            />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="Street" /> Terrain souhaité</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <Toggle
                                label="Avez-vous un terrain ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_PossedeTerrain}
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_PossedeTerrain", isChecked, this._onVerificationFormulaire)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Comment envisagez-vous votre terrain ?"
                                maxLength={MaxLengths.souhait.mi_TerrainEnvisage}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_TerrainEnvisage", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_TerrainEnvisage}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Quel serait le terrain idéal ? A quel endroit ?"
                                maxLength={MaxLengths.souhait.mi_TerrainIdealEtEmplacement}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_TerrainIdealEtEmplacement", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_TerrainIdealEtEmplacement}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Y-a-t-il une commune que vous ne souhaitez pas habiter ?"
                                maxLength={MaxLengths.souhait.mi_CommuneNonSouhaitee}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_CommuneNonSouhaitee", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_CommuneNonSouhaitee}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="L'idéal par rapport à votre travail ?"
                                maxLength={MaxLengths.souhait.mi_EmplacementIdeal}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_EmplacementIdeal", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_EmplacementIdeal}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Si enfants, avez-vous une nounou ? Où habite t-elle ?"
                                maxLength={MaxLengths.souhait.mi_LieuNounouEnfants}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_LieuNounouEnfants", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_LieuNounouEnfants}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <Toggle
                                label="Doit-il être piscinable ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_EstTerrainPiscinable}
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_EstTerrainPiscinable", isChecked, this._onVerificationFormulaire)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <Toggle
                                label="Lotissement ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_EstDansLotissement}
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_EstDansLotissement", isChecked, this._onVerificationFormulaire)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Qu'est ce qui est le plus important pour vous ? (Proximité commerces, choix quartier, surface terrain, ...)"
                                maxLength={MaxLengths.souhait.mi_PointsImportantsTerrain}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_PointsImportantsTerrain", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_PointsImportantsTerrain}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <Toggle
                                label="En avez-vous visité ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_AVisiteTerrains}
                                onChange={(e, isChecked) => {
                                    if (!isChecked) {
                                        let souhaitTrav = { ...this.state.souhait };
                                        souhaitTrav.mI_AVisiteTerrains = isChecked;
                                        souhaitTrav.mI_NbTerrainsVisites = null;
                                        souhaitTrav.mI_LieuxTerrainsVisites = null;
                                        souhaitTrav.mI_PersonneTerrainsVisites = null;

                                        this.setState({
                                            souhait: souhaitTrav
                                        }, this._onVerificationFormulaire);
                                    }
                                    else {
                                        Scriba.state().setObjetPropriete(this, "souhait", "mI_AVisiteTerrains", isChecked, this._onVerificationFormulaire);
                                    }
                                }}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Si OUI, combien ?"
                                disabled={!this.state.souhait.mI_AVisiteTerrains}
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'souhait', 'mI_NbTerrainsVisites', false, 0)}
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'souhait', 'mI_NbTerrainsVisites', this._onVerificationFormulaire)}
                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbTerrainsVisites', e.target.value, 'fr', this._onVerificationFormulaire)}
                                onChanged={value => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbTerrainsVisites', value, 'fr', this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'mI_NbTerrainsVisites', e, false, 0)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                disabled={!this.state.souhait.mI_AVisiteTerrains}
                                label="A quels endroits ?"
                                maxLength={MaxLengths.souhait.mi_LieuxTerrainsVisites}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_LieuxTerrainsVisites", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_LieuxTerrainsVisites}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                disabled={!this.state.souhait.mI_AVisiteTerrains}
                                label="Avec qui ?"
                                maxLength={MaxLengths.souhait.mi_PersonneTerrainsVisites}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_PersonneTerrainsVisites", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_PersonneTerrainsVisites}
                            />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="CityNext" /> Logement actuel</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUIComboBox
                                idValeurParDefaut="0"
                                label="Etes-vous propriétaire ou locataire ?"
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "souhait", "situationActuelle", option.key, this._onVerificationFormulaire)}
                                options={[
                                    { key: 'Propriétaire', text: 'Propriétaire' },
                                    { key: 'Locataire', text: 'Locataire' }
                                ]}
                                selectedKey={this.state.souhait.situationActuelle}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUIComboBox
                                idValeurParDefaut="0"
                                label="Est-ce un appartement ou une maison ?"
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "souhait", "mI_TypeLogementActuel", option.key, this._onVerificationFormulaire)}
                                options={[
                                    { key: 'Appartement', text: 'Appartement' },
                                    { key: 'Maison individuelle', text: 'Maison individuelle' }
                                ]}
                                selectedKey={this.state.souhait.mI_TypeLogementActuel}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUITextField
                                label="A quel endroit ?"
                                maxLength={MaxLengths.contact.mi_LieuLogementActuel}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_LieuLogementActuel", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.lieuLogementActuel}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="Depuis combien de temps ?"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'souhait', 'mI_NbAnneesLogementActuel', false, 0)}
                                suffix="années"
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'souhait', 'mI_NbAnneesLogementActuel', this._onVerificationFormulaire)}
                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbAnneesLogementActuel', e.target.value, 'fr', this._onVerificationFormulaire)}
                                onChanged={value => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbAnneesLogementActuel', value, 'fr', this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'mI_NbAnneesLogementActuel', e, false, 0)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Votre loyer est-il important ?"
                                maxLength={MaxLengths.contact.mi_LoyerLogementActuel}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_LoyerLogementActuel", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_LoyerLogementActuel}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Voulez-vous conserver la même chose ou un peu plus pour votre maison ?"
                                maxLength={MaxLengths.contact.mi_ConservationsElements}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ConservationsElements", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_ConservationsElements}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Que vous manque t-il dans votre logement ?"
                                maxLength={MaxLengths.contact.mi_ManquesLogementActuel}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ManquesLogementActuel", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_ManquesLogementActuel}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Et que souhaitez-vous dans votre future maison ?"
                                maxLength={MaxLengths.contact.mi_SouhaitFutureMaison}
                                multiline
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_SouhaitFutureMaison", newValue, this._onVerificationFormulaire)}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                rows={3}
                                value={this.state.souhait.mI_SouhaitFutureMaison}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <TextField // Note KP : TextFieldNombre en cours de test
                                label="C'est un logement de combien de chambres ?"
                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'souhait', 'mI_NbChambresLogementActuel', false, 0)}
                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'souhait', 'mI_NbChambresLogementActuel', this._onVerificationFormulaire)}
                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbChambresLogementActuel', e.target.value, 'fr', this._onVerificationFormulaire)}
                                onChanged={value => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbChambresLogementActuel', value, 'fr', this._onVerificationFormulaire)}
                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'mI_NbChambresLogementActuel', e, false, 0)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <EUIComboBox
                                idValeurParDefaut="0"
                                label="Est-ce une résidence principale ou secondaire ?"
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "souhait", "mI_TypeResidence", option.key, this._onVerificationFormulaire)}
                                options={[
                                    { key: 'Principale', text: 'Principale' },
                                    { key: 'Secondaire', text: 'Secondaire' }
                                ]}
                                selectedKey={this.state.souhait.mI_TypeResidence}
                            />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="Home" /> Maison souhaitée</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <Label>Comment envisagez-vous votre future maison ?</Label>
                        </div>
                        <div className="ms-Grid-col  ms-sm12 ms-xl4">
                            <Toggle
                                label="Etage ?"
                                onText="Oui"
                                offText="Non, plain-pied"
                                checked={this.state.souhait.mI_AvecEtage}
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_AvecEtage", isChecked, this._onVerificationFormulaire)}
                            />
                        </div>
                        <div className="ms-Grid-col  ms-sm12 ms-xl4">
                            <Toggle
                                label="Sous-sol ?"
                                onText="Oui"
                                offText="Non"
                                checked={this.state.souhait.mI_AvecSousSol}
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "souhait", "mI_AvecSousSol", isChecked, this._onVerificationFormulaire)}
                            />
                        </div>
                        <div className="ms-Grid-col  ms-sm12 ms-xl4">
                            <SpinButton
                                label="Nombre de pièces"
                                labelPosition={Position.top}
                                value={this.state.souhait.mI_NbPieces}
                                min={1}
                                max={10}
                                step={1}
                                onValidate={(value) => {
                                    if (Number(value) > 10 || Number(value) <= 0 || value.trim().length === 0 || isNaN(+value)) {
                                        return '1';
                                    }
                                    else {
                                        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbPieces', String(value), 'fr', this._onVerificationFormulaire);
                                    }

                                    return String(value);
                                }}
                                onIncrement={(value) => {
                                    value = Number(value);
                                    if ((Number(value) + 1) > 10) {
                                        return '10';
                                    } else {
                                        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbPieces', String(value + 1), 'fr', this._onVerificationFormulaire);
                                        return String(value + 1);
                                    }
                                }}
                                onDecrement={(value) => {
                                    value = Number(value);
                                    if ((Number(value) - 1) <= 0) {
                                        return '1';
                                    } else {
                                        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'souhait', 'mI_NbPieces', String(value - 1), 'fr', this._onVerificationFormulaire);
                                        return String(value - 1);
                                    }
                                }}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Menuiseries"
                                maxLength={MaxLengths.souhait.mi_Menuiseries}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Menuiseries", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_Menuiseries}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Sanitaires"
                                maxLength={MaxLengths.souhait.mi_Sanitaires}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Sanitaires", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_Sanitaires}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Volets"
                                maxLength={MaxLengths.souhait.mi_Volets}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Volets", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_Volets}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Chauffage"
                                maxLength={MaxLengths.souhait.mi_Chauffage}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Chauffage", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_Chauffage}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Annexes"
                                maxLength={MaxLengths.souhait.mi_Annexes}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Annexes", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_Annexes}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Travaux réservés"
                                maxLength={MaxLengths.souhait.mi_TravauxReserves}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_TravauxReserves", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_TravauxReserves}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Quel type d'architecture souhaitez-vous pour votre future maison ? (volumétrie, toiture, aspect, etc…)"
                                maxLength={MaxLengths.contact.mi_TypeArchitecture}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_TypeArchitecture", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_TypeArchitecture}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <div className="ms-Grid-col ms-sm8 ms-md10">
                                <Upload label="Dessinons ensemble votre maison" value={this.state.souhait.mI_DessinMaison} onChange={(e) => this._onUploadFileChange(e)} />
                            </div>
                            <div className="ms-Grid-col ms-sm2 ms-md1">
                                {this.state.souhait.mI_DessinMaison !== undefined && this.state.souhait.mI_DessinMaison != null ? <IconButton iconProps={{ iconName: 'Download' }} title="Télécharger" ariaLabel="Télécharger" onClick={() => this._telechargementDessinMaison()} /> : null}
                            </div>
                            <div className="ms-Grid-col ms-sm2 ms-md1">
                                {this.state.souhait.mI_DessinMaison !== undefined && this.state.souhait.mI_DessinMaison != null ? <IconButton iconProps={{ iconName: 'Delete' }} title="Supprimer" ariaLabel="Supprimer" onClick={() => this._onIconButtonClick()} /> : null}
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Qu'est ce qui est le plus important pour vous dans votre projet ?"
                                maxLength={MaxLengths.souhait.mi_ElementsImportantsProjet}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ElementsImportantsProjet", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_ElementsImportantsProjet}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Si par rapport à tous vos souhaits nous n'arrivons pas à concevoir la maison de vos rêves, sur quoi seriez-vous prêts à faire l'impasse ? (laisser 3-4 secondes). Provisoirement, peut-être (si aucune réponse, revenir sur le financement)."
                                maxLength={MaxLengths.souhait.mi_Concessions}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_Concessions", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_Concessions}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Commentaire après R1"
                                maxLength={MaxLengths.souhait.mi_CommentairesApresRdv1}
                                multiline
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_CommentairesApresRdv1", newValue, this._onVerificationFormulaire)}
                                rows={3}
                                value={this.state.souhait.mI_CommentairesApresRdv1}
                            />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row" style={{ marginBottom: '20px' }}>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="ms-Grid-col ms-sm12">
                            <div className="ms-font-xl titreRubriqueFicheSouhait_MaisonIndividuelle"><Icon iconName="Contact" /> Son cas</div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl4">
                            <EUITextField
                                label="Profil Mme"
                                maxLength={MaxLengths.souhait.mi_ProfilMme}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ProfilMme", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_ProfilMme}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl4">
                            <EUITextField
                                label="Profil M."
                                maxLength={MaxLengths.souhait.mi_ProfilMr}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "souhait", "mI_ProfilMr", newValue, this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_ProfilMr}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl4">
                            <EUIDatePicker
                                label="Prise du R2"
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "souhait", "mI_DateRdv2", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                value={this.state.souhait.mI_DateRdv2}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Panel>);
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onRenderFooterContentPanel = () => {
        let boutonActif = this.state.onActiveBoutonEnregistrer;

        return (<div>
            <PrimaryButton name="EnregistrerSouhait" onClick={() => this._enregistrementSouhait()} style={{ marginRight: '8px' }} disabled={!boutonActif}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
        </div>
        );
    };

    _onUploadFileChange(event) {
        let _this = this;
        let souhaitTrav = { ...this.state.souhait };
        let fichier = event.target.files[0];

        var reader = new FileReader();

        reader.addEventListener('load', function () {
            souhaitTrav.mI_DessinMaison = Scriba.fichier().ByteArrayVersBase64(reader.result);
            _this.setState({ souhait: souhaitTrav }, this._onVerificationFormulaire);
        });

        reader.readAsArrayBuffer(fichier);
    }

    _onIconButtonClick() {
        Scriba.state().setObjetPropriete(this, 'souhait', 'mI_DessinMaison', null, this._onVerificationFormulaire);
    }

    _telechargementDessinMaison() {
        let document = Scriba.fichier().Base64VersByteArray(this.state.souhait.mI_DessinMaison);
        return Scriba.fichier().EnregisterSous(document, "Plan_" + this.state.souhait.nom + "_" + this.state.idSouhait, "image/jpeg");
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _enregistrementSouhait() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du souhait en cours'
        });

        var enregistrementSouhait = DataSouhait._onEnregistrementSouhaitMaisonIndividuelle(this.state.idContact, this.state.idSouhait, this.state.souhait);

        enregistrementSouhait
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let retourData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(retourData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _chargementDonnees() {
        let idContactRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idContact, [this.state.idContact]);
        let idSouhaitRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idSouhait, [this.state.idSouhait]);

        if (idContactRenseigneeEtDifferent && idSouhaitRenseigneeEtDifferent) {
            if (this.props.idContact !== 0 & this.props.idSouhait !== 0) {
                this.setState({
                    enCoursDeTraitement: true,
                    messageEnCoursTraitement: 'Chargement du souhait'
                });

                var chargementSouhait = DataSouhait._onChargementSouhaitMaisonIndividuelle(this.props.idContact, this.props.idSouhait);

                chargementSouhait
                    .then(responseFetch => {
                        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                        if (retourVerif === null) {
                            let retourData = responseFetch.reponseAPIobjet;
                            let itemSouhait = retourData[0][0];
                            let peutCreerSouhait = retourData[1];
                            let peutModifierSouhait = retourData[2];

                            let stateTemp = {};
                            stateTemp.idContact = itemSouhait.idContact;
                            stateTemp.idSouhait = itemSouhait.idSouhait;
                            stateTemp.souhait = itemSouhait;
                            stateTemp.titrePanelCalendrierReservation = 'Feuille de découverte / ' + itemSouhait.nom + ' ' + itemSouhait.prenom;
                            stateTemp.peutCreerSouhait = peutCreerSouhait;
                            stateTemp.peutModifierSouhait = peutModifierSouhait;

                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                        }
                        else {
                            Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                        }
                    });
            }
        }
        else if (this.props.idContact !== 0 & this.props.idSouhait === 0) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des droits'
            });

            var chargementDroitSouhait = DataSouhait._onChargementDroitsSouhait(this.props.idContact, this.props.idSouhait);

            chargementDroitSouhait
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let retourData = responseFetch.reponseAPIobjet;
                        let peutCreerSouhait = retourData[1];
                        let peutModifierSouhait = retourData[2];

                        let stateTemp = {};
                        stateTemp.idContact = this.props.idContact;
                        stateTemp.idSouhait = 0;
                        stateTemp.souhait = {};
                        stateTemp.peutCreerSouhait = peutCreerSouhait;
                        stateTemp.peutModifierSouhait = peutModifierSouhait;

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'Souhait_MaisonIndividuelle', this.state.souhait, (this.state.idSouhait > 0 ? 'Modification' : 'Création'));
    }

    componentDidMount() {
        //méthode appelée lors du montage du composant
    }

    componentDidUpdate() {
        //méthode appelée lors de la mise à jour du composant
        //if (((this.props.idContact != null & this.props.idContact !== this.state.idContact) || (this.props.idSouhait !== undefined & this.props.idSouhait != null & this.props.idSouhait !== this.state.idSouhait)) & !this.state.enCoursDeTraitement) {
        //    this._chargementDonnees();
        //}
    }

    componentWillUnmount() {
        //immédiatement avant le démontage du composant. NE JAMAIS APPELER SetState ICI
    }

    render() {
        return this._creationContent();
    }
}